<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">Make Pass User staff</h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form role="form" [formGroup]="form">
    <div class="box-body">

      <div class="form-group col-sm-12 col-xs-12">
        <label for="email_or_mobile">Email or MobileNo*</label>
        <input
          type="text"
          class="form-control"
          formControlName="email_or_mobile"
          placeholder="Email or MobileNo"
          />
        @if (
          form.controls['email_or_mobile'].hasError('required') &&
          (isSubmitted || form.controls['email_or_mobile'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }

      </div>

      <div class="form-group col-sm-12 col-xs-12">
        <label for="user_type">User Type*</label>
        <select class="form-control" formControlName="user_type" (change)="userTypeChange()">
          <option value="">select a user type</option>
          @for (item of user_types; track item; let i = $index) {
            <option
              [value]="item.name"
              >{{ item.name }}</option
              >
            }
          </select>
          @if (
            form.controls['user_type'].hasError('required') &&
            (isSubmitted || form.controls['user_type'].touched)
            ) {
            <control-message
              message="This field is required."
            ></control-message>
          }
        </div>





      </div>
      <!-- /.box-body -->

      <div class="box-footer">
        <button
          type="submit"
          (click)="submitForm()"
          class="btn btn-info pull-right"
          >
          Submit
        </button>
      </div>
    </form>
  </div>
